import React from "react";
import ISOHeader200001 from "../../../components/ISO Certificates/ISO 20000-1-2018/ISOHeader200001";
import ISOContent200001 from "../../../components/ISO Certificates/ISO 20000-1-2018/ISOContent200001";
import ISOSpecification200001 from "../../../components/ISO Certificates/ISO 20000-1-2018/ISOSpecification200001";
import ISOServiceIndia9001 from "../../../components/ISO Certificates/ISO Common/ISOServiceIndia9001";

const ISO2000012018 = () => {
  return (
    <div>
      <ISOHeader200001 />
      <ISOContent200001 />
      <ISOServiceIndia9001 />
      <ISOSpecification200001 />
    </div>
  );
};

export default ISO2000012018;
